module.exports = __webpack_public_path__ + "img/levelup-icon-income.ed394d3c.svg";